import React, { useEffect, useState } from 'react';
import { useDigitalCardState } from 'src/components/_common/DigitalCard/_hooks/useDigitalCard';
import styled, { keyframes } from 'styled-components';

const DEFAULT_WIDTH = 100;
const DEFAULT_BLUR = 60;
/**
 * [글레어(반짝임) 효과 컴포넌트]
 *
 * @description
 * 카드에 반짝이는 효과를 추가합니다.
 * 사용자 인터랙션(틸트) 중에는 자동으로 숨겨집니다.
 * 이미지 로드 전에는 렌더링되지 않습니다.
 */
const GlareEffect = () => {
  const { cardRef, isInteracting, isAllResourcesLoaded } = useDigitalCardState();
  const [width, setWidth] = useState<number>(DEFAULT_WIDTH);
  const [blur, setBlur] = useState<number>(DEFAULT_BLUR);

  useEffect(() => {
    const calculateScale = () => {
      if (cardRef?.current?.clientWidth) {
        setWidth(cardRef.current.clientWidth / 3);
        setBlur(cardRef.current.clientWidth / 5);
      }
    };

    // ResizeObserver 생성
    const resizeObserver = new ResizeObserver(calculateScale);

    // cardRef가 존재하면 observe 시작
    if (cardRef?.current) {
      resizeObserver.observe(cardRef.current);
    }

    // cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []); // cardRef는 의존성에서 제거 가능

  if (!isAllResourcesLoaded) {
    return null;
  }

  return (
    <GlareEffectWrapper>
      <StyledGlareEffect $isInteracting={isInteracting} $width={width} $blur={blur} />
    </GlareEffectWrapper>
  );
};

export default GlareEffect;

/* 글레어 효과 애니메이션 */
const glareAnimation = keyframes`
  0% {
      transform: translate(-50%, -80%) rotate(45deg);
  }
  30% {
    transform: translate(-50%, 100%) rotate(45deg);
  }
  100% {
    transform: translate(-50%, 100%) rotate(45deg);
  }
`;

const GlareEffectWrapper = styled.div`
  position: absolute;
  width: inherit;
  height: inherit;
  overflow: hidden;
`;

const StyledGlareEffect = styled.div<{ $isInteracting: boolean; $width: number; $blur: number }>`
  position: absolute;
  display: ${({ $isInteracting: isInteracting }) => (isInteracting ? 'none' : 'block')};
  width: ${({ $width }) => $width}px;
  height: 100%;
  left: 50%;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 0 5px 3px rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -100%) rotate(45deg);
  animation: ${glareAnimation} 5s ease infinite;
  animation-delay: 2s;

  filter: blur(${({ $blur }) => $blur}px);

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
`;
